// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@tps/App/SharedStyles/CartLineSharedStyles";
import { quickOrderProductListStyles } from "@tps/Overrides/Widgets/QuickOrder/QuickOrderProductList";
import { xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

quickOrderProductListStyles.wrapper = {
    css: css`
        padding-bottom: 0;
    `,
};

quickOrderProductListStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

quickOrderProductListStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

quickOrderProductListStyles.productNumber = {
    ...cartLineSharedStyles.productPartNumbers,
};

quickOrderProductListStyles.availability = {
    ...cartLineSharedStyles.productAvailability,
};

quickOrderProductListStyles.price = {
    ...cartLineSharedStyles.productPrice,
};

quickOrderProductListStyles.priceTotal = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

quickOrderProductListStyles.removeProductIcon = {
    ...cartLineSharedStyles.removeCartLineIcon?.icon?.iconProps,
};

quickOrderProductListStyles.removeProductClickable = {
    css: css`
        margin-left: 20px;
        &&&& {
            outline-style: none;
        }
        ${xScreen("lte", "md")} {
            padding-top: 18px;
        }
    `,
};

quickOrderProductListStyles.addToListLink = {
    link: {
        ...cartLineSharedStyles.addToListLink,
    },
};

quickOrderProductListStyles.qtyRemoveGridItem = {
    ...cartLineSharedStyles.QtyRemoveGridItem,
};

quickOrderProductListStyles.quantityOrdered = {
    ...cartLineSharedStyles.quantity,
};
